export default __webpack_public_path__ + "static/media/art-2-main-lg.756bde15.jpg";